import * as THREE from 'three'
import {SectionBase} from "./SectionBase.js";

export default class ProjectsSection extends SectionBase {
    constructor(_options) {
        // Options
        super(_options);
    }

    setGeometries() {
        this.geometries = {}
        this.geometries.floor = new THREE.PlaneGeometry(16, 8)
    }

    setMeshes() {
        this.meshes = {}
        // this.meshes.boardStructure = this.objects.getConvertedMesh(this.resources.items.projectsBoardStructure.scene.children, { floorShadowTexture: this.resources.items.projectsBoardStructureFloorShadowTexture })
        this.resources.items.areaOpenTexture.magFilter = THREE.NearestFilter
        this.resources.items.areaOpenTexture.minFilter = THREE.LinearFilter
        this.meshes.boardPlane = this.resources.items.projectsBoardPlane.scene.children[0]
        this.meshes.areaLabel = new THREE.Mesh(new THREE.PlaneGeometry(2, 0.5), new THREE.MeshBasicMaterial({
            transparent: true,
            depthWrite: false,
            color: 0xffffff,
            alphaMap: this.resources.items.areaOpenTexture
        }))
        this.meshes.areaLabel.matrixAutoUpdate = false
    }

    setItemConfigs() {
        this.list = [
            {
                name: 'Three.js Journey',
                interactionTypes: ['showIntro'],
                imageSources:
                    [
                        './models/projects/threejsJourney/slideA.webp',
                        './models/projects/threejsJourney/slideB.webp',
                        './models/projects/threejsJourney/slideC.webp'
                    ],
                floorTexture: this.resources.items.projectsThreejsJourneyFloorTexture,
                link:
                    {
                        href: 'https://www.tu-darmstadt.de/kompaki/wissenssammlung/wissensnugget_2/detailseiten_2/standardseite_184.de.jsp',
                        x: -4.8,
                        y: -3,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions:
                    []
            },
            // Todo: Problem mit Überschneidung von Texturen lösen
            // Veränderung der Project Klasse um innerhalb einer section
            // In einem Project auch änderungen an den bodentexturpositionen vornehmen zu können
            {
                name: 'Chartogne Taillet',
                cameraAngle: 'projects',
                interactionTypes: ['showTexture'],
                imageSources:
                    [
                        './models/projects/chartogne/slideA.jpg',
                        './models/projects/chartogne/slideB.jpg',
                        './models/projects/chartogne/slideC.jpg'
                    ],
                floorTexture: this.resources.items.projectsChartogneFloor1Texture,
                floorTextureOffsetY: 1,
                floorTextureLeft: this.resources.items.projectsChartogneFloorTexture,
                link:
                    {
                        href: 'https://www.tu-darmstadt.de/kompaki/wissenssammlung/wissensnugget_2/detailseiten_2/standardseite_185.de.jsp',
                        x: +4.2,
                        y: -3.3,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions:
                    [
                        {type: 'awwwards', x: -6, y: -5.5},
                        {type: 'umsetzung', x: -1, y: -5.7},
                        {type: 'fwa', x: 3.1, y: -5.7},
                        {type: 'cssda', x: 6.2, y: -5.7}
                    ]
            },

        ]
    }

    setWalls() {
    }

    setRoads() {
    }

    setStatic() {
    }
}
